import {getConfigs} from '@/api/configApi';

const getLogConfig = (configs) => {
  const [config] = configs;
  return {
    browserLogLevel: config?.logConfig?.browserLogLevel,
    logLevel: config?.logConfig?.logLevel,
    logMaxStackSize: config?.logConfig?.logMaxStackSize,
    logKey: config?.logConfig?.logKey,
    logger: config?.logConfig?.browserLogLevel >= (config?.logConfig?.logLevel || 2),
  };
};

// eslint-disable-next-line import/prefer-default-export
export const initAppConfig = async () => {
  const configs = await getConfigs;
  return getLogConfig(configs);
};
